<div class="rounded-2xl px-3 py-1 bg-black text-white text-medium text-xs">
    {{getTypeString()}}
</div>
